/** @jsxImportSource @emotion/react */

import {
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFlexItem,
  EuiIcon,
  EuiSpacer,
  EuiTitle,
} from "@inscopix/ideas-eui";
import "ag-grid-enterprise";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { ParametersEditor } from "./ParametersEditor/ParametersEditor";
import { ResultsEditor } from "./ResultsEditor/ResultsEditor";
import { ToolEditorSaveStatus } from "../../components/ToolEditorSaveStatus";
import { CallOutError } from "components/CallOutError/CallOutError";
import { ResourcesEditor } from "./ResourcesEditor/ResourcesEditor";
import { ButtonDownloadToolSpec } from "components/ToolEditor/components/ButtonDownloadToolSpec";

export const ToolEditorSpecEditor = () => {
  const toolVersionId = useToolEditorContext((s) => s.toolVersionId);
  const params = useToolEditorContext((s) => s.draftSpec?.params);
  const results = useToolEditorContext((s) => s.draftSpec?.results);
  const resources = useToolEditorContext((s) => s.draftSpec?.resources);
  const addResultColumn = useToolEditorContext((s) => s.addResultColumn);

  if (
    params === undefined ||
    results === undefined ||
    resources === undefined
  ) {
    return <CallOutError />;
  }

  return (
    <EuiFlexGroup
      direction="column"
      gutterSize="s"
      style={{ height: 0, minHeight: 300 }}
    >
      <EuiFlexItem grow={false}>
        <EuiFlexGroup alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiTitle size="m">
              <h2>Configure Your Tool</h2>
            </EuiTitle>
          </EuiFlexItem>
          <EuiFlexItem grow={false} css={{ marginLeft: 50 }}>
            <ToolEditorSaveStatus />
          </EuiFlexItem>
          <EuiFlexItem grow={false} css={{ marginLeft: "auto" }}>
            <ButtonDownloadToolSpec toolVersionId={toolVersionId} />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiSpacer size="xs" />
      <EuiFlexItem grow={false} css={{ height: 40 }}>
        <EuiTitle size="s">
          <h3>Parameters</h3>
        </EuiTitle>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ParametersEditor rowData={params} />
      </EuiFlexItem>
      <EuiSpacer size="xs" />
      <EuiFlexItem grow={false} css={{ height: 40 }}>
        <EuiFlexGroup alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiTitle size="s">
              <h3>Outputs</h3>
            </EuiTitle>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButtonEmpty onClick={addResultColumn}>
              <EuiFlexGroup alignItems="center" gutterSize="xs">
                <EuiIcon type={"plus"} /> Add Output Column
              </EuiFlexGroup>
            </EuiButtonEmpty>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ResultsEditor rowData={results} />
      </EuiFlexItem>
      <EuiSpacer size="xs" />
      <EuiFlexItem grow={false} css={{ height: 40 }}>
        <EuiFlexGroup alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiTitle size="s">
              <h3>Default Resources</h3>
            </EuiTitle>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ResourcesEditor resources={resources} />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
